@if (value >= 0 && options && options.ceil > 0) {
  <div
    class="slider mat-typography mat-body mat-app-background"
    >
    <h3>
      Use the slider to see how the Advanced Premium Tax Credit (APTC) can adjust the monthly premium. The applicant can choose how much of the credit to apply toward the premium.
      <img src=''
        [matTooltip]="'This is an Advanced Premium Tax Credit (APTC) that can be used right away, or saved for later. The tax credit can be used to lower the monthly premium cost of an individual, metal level qualified health plan.  The applicant(s) can choose how much of the credit to apply toward the monthly premium.'"
        />
        <!-- alt="This is an Advanced Premium Tax Credit (APTC) that can be used right away, or saved for later. The tax credit can be used to lower the monthly premium cost of an individual, metal level qualified health plan.  The applicant(s) can choose how much of the credit to apply toward the monthly premium." -->
      </h3>
      <div>
        <p>{{value}} /month X 12 months = {{yearlyATPC}} towards monthly premiums</p>
        <p>+ ${{federalTaxReturnCredit}} tax credit on the applicant's Federal tax return</p>
        <p>${{totalPremiumCredit}} total Advanced Premium Tax Credit (APTC)</p>
      </div>
      <ngx-slider
        [(value)]="value"
        [options]="options"
        (valueChange)="valueChange($event)"
      ></ngx-slider>
    </div>
  }
